import React from 'react'
import PropTypes from 'prop-types'
import { Button, Tooltip } from 'reactstrap'
import styles from './LightSlatePlugin.scss'
import { TYPE, TRIGGER_KEY, hasLight, onClickButton } from './LightSlatePluginContainer'

class LightButton extends React.Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  render () {
    const { state: editorState, noTooltip, onChange, style } = this.props
    const isActive = hasLight(editorState)

    const customStyle = {fontWeight: 'lighter'}

    return (
      <Button
        id={'LightButton' + (noTooltip ? '' : this.uid)}
        style={{...style, ...customStyle}}
        onClick={e => onChange(onClickButton(e, editorState))}
        color={isActive ? 'primary' : 'secondary'}
        className={styles.LightButton}
      > {TYPE}
        {
          !noTooltip &&
          <Tooltip placement='top' isOpen={this.state.tooltipOpen} target={'LightButton' + this.uid} toggle={this.toggle}>
            {TYPE} (CTL+{TRIGGER_KEY.toUpperCase()})
          </Tooltip>
        }
      </Button>
    )
  }
}

LightButton.propTypes = {
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default LightButton



// WEBPACK FOOTER //
// ./src/components/LightSlatePlugin/LightButton.js